export const SINGLE_COLUMN_BREAKPOINT = 600;
export const MASONRY_BREAKPOINT = 960;

export const masonryColumns = () => {
    if (typeof window === "undefined") return 4;
    if (window.innerWidth < SINGLE_COLUMN_BREAKPOINT) return 1;
    if (window.innerWidth < MASONRY_BREAKPOINT) return 2;
    return 4;
};

const ratioHeight = (ratio) => {
    const [w, h] = String(ratio).split("/").map((part) => Number(part.trim()));
    return w > 0 && h > 0 ? h / w : 1;
};

export const splitIntoColumns = (assets, columnCount, ratios) => {
    const buckets = Array.from({length: columnCount}, () => []);
    const heights = new Array(columnCount).fill(0);
    assets.forEach((asset, index) => {
        const target = heights.indexOf(Math.min(...heights));
        buckets[target].push({asset, index});
        heights[target] += ratioHeight(ratios[index % ratios.length]);
    });
    return buckets;
};
